module.exports = __webpack_public_path__ + "img/1.5ee29017.png";